<template>
    <div class="container files">
        <div class="row files__cats">
            <div class="col-md-6 col-lg-2" v-for="cat in cats" :key="cat.id">
                <router-link :to="{name: 'Files', params: { id: cat.id }}" class="files__cats-item">
                    <p>#{{ cat.id }}</p>
                    <p>{{ cat.name }}</p>
                </router-link>
            </div>
        </div>
        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'
import { store } from '@/app/store'

export default {
  name: 'CategoriesComponent',
    components: {
        
    },
  data () {
    return {
        pending: true,
        cats: {}         
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  mounted: function() {
    if( !this.user || this.user.id != 1 ) {
        this.$gtag.pageview({
            page_path: '/pliki',
        })
    }
  },
  beforeRouteEnter(to, from, next) {
    /**
     * Get current user object.
     */
    Vue.axios({
      method: 'get',
      url: '/downloadables/categories'
    })
    .then(response => { 
        next(vm => {
            vm.cats = response.data.data
            store.dispatch('setFileCats', response.data.data)
        })
    })
    .catch(error => next(false))
  },
  methods: {
  }
}
</script>


// WEBPACK FOOTER //
// src/app/home/files/CategoriesComponent.vue